import { Controller } from '@hotwired/stimulus';

export default class CertificateApplicationSummary extends Controller {
  static targets = [
    'totalFees',
    'totalAmount',
    'totalQuantity',
    'deliveryCost',
    'expressCost',
    'isExpress'
  ];

  static values = {
    postAmounts: Array
  }

  connect() {
    this.update();
  }

  update() {
    const totalFees     = Number(this.totalAmountTarget.dataset.totalFees);
    const totalQuantity = Number(this.totalQuantityTarget.textContent);
    const isExpress     = this.isExpressTarget.checked;
    const postAmount    = this.postAmountsValue.find(({lower_limit, upper_limit}) => lower_limit <= totalQuantity && totalQuantity <= upper_limit);
    const deliveryCost  = postAmount.amount
    const expressCost   = isExpress ? postAmount.express_amount : 0;
    const totalCost     = totalFees + deliveryCost + expressCost;

    this.totalAmountTarget.textContent  = Intl.NumberFormat('ja-JP').format(totalCost);
    this.deliveryCostTarget.textContent = Intl.NumberFormat('ja-JP').format(deliveryCost);
    this.expressCostTarget.textContent  = Intl.NumberFormat('ja-JP').format(expressCost);
  }
}
